import React, { useState, useEffect, Fragment } from "react";
import { connect } from "react-redux";
import { goBack, push } from "connected-react-router";
import { ResponsiveHeader } from "pages/_components/header";
import Row from "react-bootstrap/lib/Row";
import Col from "react-bootstrap/lib/Col";
import classNames from "classnames";
import I18n from "pages/_components/I18n";
import Button from "pages/_components/Button";
import MainContainer from "pages/_components/MainContainer";
import { bool, func, shape, string } from "prop-types";
import { actions as enrollmentActions, selectors as enrollmentSelectors } from "reducers/enrollment";
import { actions as onboardingActions, selectors as onboardingSelectors } from "reducers/onboarding";
import { actions as modalActions } from "reducers/modal";
import { Grid } from "react-bootstrap";
import * as configUtils from "util/config";
import ErrorPopup from "../../onboarding/_components/ErrorPopup";
import Stepper from "../../onboarding/_components/Stepper";

const PAGE_ID = "StepSelectSecuritySeal";

const StepSelectSecuritySeal = ({
    dispatch,
    isMobile,
    securitySeals,
    currentSecuritySealId,
    fetching,
    exchangeToken,

    password,
    passwordConfirmation,
    username,
    documentData,
    userMigrationStatus,
    fetchingUserCreation,
    signerSkipVU,
}) => {
    const [disableValidateId, setDisableValidateId] = useState(false);
    const [isValidating, setIsValidating] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        const disabledValidate = configUtils.getBoolean("onb.skipIDValidation", false);
        setDisableValidateId(disabledValidate);
    }, []);

    useEffect(() => {
        dispatch(enrollmentActions.requestSecuritySeals());
    }, []);

    useEffect(() => {
        if (isValidating && userMigrationStatus && userMigrationStatus === "SUCCESS") {
            setIsValidating(false);
            dispatch(push("/migration/stepUserFinishMigration"));
        } else if (isValidating && userMigrationStatus?.length) {
            setIsValidating(false);
            setError(userMigrationStatus);
            dispatch(modalActions.modalShow());
        }
    }, [isValidating, userMigrationStatus]);

    const handleClick = (id) => {
        dispatch(enrollmentActions.changeSecuritySealConfirmationPre(id));
    };

    const submitUser = () => {
        setIsValidating(true);
        dispatch(
            enrollmentActions.changeSecuritySealConfirmation(
                currentSecuritySealId,
                securitySeals[currentSecuritySealId],
            ),
        );

        dispatch(
            onboardingActions.updateMigratedUser(
                {
                    _password: password,
                    _passwordConfirmation: passwordConfirmation,
                    _securitySeal: currentSecuritySealId,
                    _userConfirmation: username,
                    cuil: disableValidateId ? signerSkipVU?.cuil : documentData?.cuil,
                    document: disableValidateId ? signerSkipVU?.documentNumber : documentData?.documentNumber,
                },
                exchangeToken,
            ),
        );
    };

    const onHeaderBack = () => {
        dispatch(goBack());
    };

    const isSealSelected = (id) => id === `${currentSecuritySealId}`;

    return (
        <Fragment>
            {isMobile && <ResponsiveHeader ticket id="onboarding.noUser.title" onBack={isMobile && onHeaderBack} />}
            <MainContainer showLoader={fetching}>
                <Stepper isMobile={isMobile} page={PAGE_ID} />
                <h1 className="text-center" style={{ textAlign: "left" }}>
                    <I18n id="onboarding.securitySeal.title" defaultValue="Elegí una imagen de seguridad" />
                </h1>
                <I18n
                    id="onboarding.securitySeal.description"
                    defaultValue="Vas a tener que recordarla al momento de ingresar a Bibank."
                />

                <div className="container--layout items-center">
                    <Grid className="form-content">
                        <Row className="justify-content-center">
                            <Col sm={12} className="col-12 image-grid">
                                <Row>
                                    {Object.entries(securitySeals).map(([id, securitySeal]) => (
                                        <Col
                                            sm={3}
                                            md={3}
                                            className={classNames("col-6", { "is-current": isSealSelected(id) })}
                                            key={`securitySeal-${id}`}>
                                            <Button
                                                className={classNames("btn-image btn-image-seal", {
                                                    "is-current": isSealSelected(id),
                                                })}
                                                id={id}
                                                label=""
                                                onClick={() => handleClick(id)}
                                                style={{
                                                    backgroundImage: `url(${securitySeal})`,
                                                    width: "4rem",
                                                    height: "4rem",
                                                }}
                                                block
                                            />
                                        </Col>
                                    ))}
                                </Row>
                            </Col>
                        </Row>
                    </Grid>
                </div>
                <div className="form-actions">
                    <Button
                        bsStyle="primary"
                        label="global.continue"
                        loading={fetching || isValidating || fetchingUserCreation}
                        onClick={submitUser}
                        disabled={!currentSecuritySealId}
                        block
                    />
                </div>
            </MainContainer>
            <ErrorPopup
                error={error}
                handleClick={() => {
                    dispatch(modalActions.modalClose());
                }}
            />
        </Fragment>
    );
};

StepSelectSecuritySeal.propTypes = {
    isMobile: bool.isRequired,
    currentSecuritySealId: string,
    dispatch: func.isRequired,
    fetching: bool.isRequired,
    exchangeToken: string.isRequired,
    securitySeals: shape({}).isRequired,

    password: string,
    passwordConfirmation: string,
    username: string,
    documentData: shape({}),
    documentType: string,
    email: string,
    mobileNumber: string,

    userMigrationStatus: string,
    fetchingUserCreation: bool.isRequired,

    onboardingWithInvitation: bool.isRequired,
    signer: shape({}).isRequired,
    signerSkipVU: shape({}),
};

StepSelectSecuritySeal.defaultProps = {
    currentSecuritySealId: "",

    password: "",
    passwordConfirmation: "",
    username: "",
    documentData: {},
    documentType: "",
    email: "",
    mobileNumber: "",

    userMigrationStatus: "",
    signerSkipVU: {},
};

const mapStateToProps = (state) => ({
    securitySeals: enrollmentSelectors.getSecuritySeals(state),
    fetching: enrollmentSelectors.getFetching(state),
    exchangeToken: enrollmentSelectors.getExchangeToken(state),
    currentSecuritySealId: enrollmentSelectors.getSelectedSecuritySealId(state),
    fetchingUserCreation: onboardingSelectors.getFetching(state),
    userMigrationStatus: onboardingSelectors.getUserMigrationStatus(state),
    password: onboardingSelectors.getPassword(state),
    passwordConfirmation: onboardingSelectors.getPasswordConfirmation(state),
    username: onboardingSelectors.getUsername(state),
    documentData: onboardingSelectors.getDocumentData(state),
    documentType: onboardingSelectors.getDocumentType(state),
    email: onboardingSelectors.getEmail(state),
    mobileNumber: onboardingSelectors.getMobileNumber(state),
    onboardingWithInvitation: onboardingSelectors.getOnboardingWithInvitation(state),
    signer: onboardingSelectors.getInvitationData(state),
    signerSkipVU: onboardingSelectors.getSigner(state),
});
export default connect(mapStateToProps)(StepSelectSecuritySeal);
